import { message } from "antd";
import axios from "axios";
import qs from "qs";
const MAX_REFRESH_RETRIES = 3;
export const AUTH_API = {
  refreshToken: async () => {
    try {
      const refreshToken = localStorage.getItem(
        `${process.env.REACT_APP_PREFIX}_refresh_token`
      );
      if (!refreshToken) {
        throw new Error("No refresh token found in localStorage.");
      }
      const instance = axios.create({
        baseURL: `${process.env.REACT_APP_API_BASE_URL_ADMIN}`,
        timeout: 30000,
        headers: {
          Authorization: `Bearer ${refreshToken}`,
        },
      });
      const response = await instance.get("/auth/refresh");
      return response.data;
    } catch (error) {
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_access_token`);
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_refresh_token`);
      throw error;
    }
  },
};
export const AxiosConfigExplore = () => {
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_EXPLORE_BASE_URL}`,
    timeout: 30000,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
  });
  let isRefreshing = false;
  let failedQueue = [];
  const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
      if (error) {
        prom.reject(error);
      } else {
        prom.resolve(token);
      }
    });

    failedQueue = [];
  };

  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem(
      `${process.env.REACT_APP_PREFIX}_access_token`
    );
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
  const refreshTokenAndRetry = async (failedRequest) => {
    try {
      const { config } = failedRequest;
      config._retryCount = config._retryCount || 0;
      if (config._retryCount >= MAX_REFRESH_RETRIES) {
        return Promise.reject(
          new Error("Max refresh token retry limit reached. Logging out!")
        );
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            config.headers.Authorization = `Bearer ${token}`;
            return axios(config);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }
      isRefreshing = true;

      const { access_token } = await AUTH_API.refreshToken();
      localStorage.setItem(
        `${process.env.REACT_APP_PREFIX}_access_token`,
        access_token
      );
      config.headers.Authorization = `Bearer ${access_token}`;

      processQueue(null, access_token);

      return axios(config);
    } catch (err) {
      processQueue(err, null);

      return Promise.reject(err);
    } finally {
      isRefreshing = false;
    }
  };

  instance.interceptors.request.use(async (config) => {
    let ipData = JSON.parse(localStorage.getItem("user_ip"));

    if (!ipData || Date.now() > ipData.expirationTime) {
      const ipAddress = await getUserIP();
      const expirationTime = Date.now() + 3600000;

      localStorage.setItem(
        "user_ip",
        JSON.stringify({ ip: ipAddress, expirationTime })
      );
      ipData = { ip: ipAddress };
    }

    config.metadata = {
      ipAddress: ipData.ip,
      currentPage: window.location.pathname,
      payload: config.data,
    };

    return config;
  });
  instance.interceptors.response.use(
    (response) => {
      const backendTime = parseInt(response.headers.get("X-Response-Time"));
      logUserAction(
        response.config.metadata.ipAddress,
        response.config.method,
        response.config.url,
        response.config.metadata.currentPage,
        response.config.metadata.payload,
        backendTime,
        response.status,
      );
      if (!response || response.status >= 400) {
        return Promise.reject(response);
      }
      return response;
    }
    // (error) => {
    //   const originalRequest = error.config;
    //   // if (error.response.status === 401 && !originalRequest._retry) {
    //   //   originalRequest._retry = true;
    //   //   return refreshTokenAndRetry(error);
    //   // }
    //   if (!error.response) {
    //     message.error("Something went wrong. Please try again later.");
    //     return Promise.reject(error);
    //   }
    //   message.error(error.response.data?.message || "Something went wrong!");
    //   return Promise.reject(error);
    // }
  );

  return instance;
};

export const AxiosConfigBenchmarking = () => {
  const token = localStorage.getItem(
    `${process.env.REACT_APP_PREFIX_LOCAL}_access_token`
  );
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_BENCHMARKING_BASE_URL}/benchmarking`,
    headers: {
      //   Authorization: `Bearer ${token}`,
    },
  });

  return instance;
};

export const AxiosConfigAdmin = () => {
  const token = localStorage.getItem(
    `${process.env.REACT_APP_PREFIX}_access_token`
  );
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL_ADMIN}`,
    timeout: 30000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  let isRefreshing = false;
  let failedQueue = [];
  const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
      if (error) {
        prom.reject(error);
      } else {
        prom.resolve(token);
      }
    });

    failedQueue = [];
  };
  const refreshTokenAndRetry = async (failedRequest) => {
    try {
      const { config } = failedRequest;
      config._retryCount = config._retryCount || 0;
      if (config._retryCount >= MAX_REFRESH_RETRIES) {
        return Promise.reject(
          new Error("Max refresh token retry limit reached. Logging out!")
        );
      }
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            config.headers.Authorization = `Bearer ${token}`;
            return axios(config);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }
      isRefreshing = true;

      const { access_token } = await AUTH_API.refreshToken();
      localStorage.setItem(
        `${process.env.REACT_APP_PREFIX}_access_token`,
        access_token
      );

      config.headers.Authorization = `Bearer ${access_token}`;

      processQueue(null, access_token);

      return axios(config);
    } catch (err) {
      processQueue(err, null);
      // localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_access_token`);
      // localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_refresh_token`);
      return Promise.reject(err);
    } finally {
      isRefreshing = false;
    }
  };

  instance.interceptors.response.use(
    (response) => {
      if (!response || response.status >= 400) {
        return Promise.reject(response);
      }
      return response.data;
    },
    (error) => {
      const originalRequest = error.config;
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        return refreshTokenAndRetry(error);
      }
      if (!error.response) {
        message.error("Something went wrong. Please try again later.");
        return Promise.reject(error);
      }
      message.error(error.response.data?.message || "Something went wrong!");
      return Promise.reject(error);
    }
  );
  return instance;
};

const logUserAction = async (
  ipAddress,
  action,
  endpoint,
  currentPage,
  payload,
  duration,
  status,
  token
) => {
  try {
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL_ADMIN}/user/logs`,
      {
        ip_address: ipAddress,
        action: action,
        endpoint: endpoint,
        current_page: currentPage,
        duration: duration,
        status_code: status,
        payload: payload,
      },
      { headers }
    );
  } catch (error) {
    console.error("Error logging action:", error);
  }
};

const getUserIP = async () => {
  try {
    const response = await axios.get("https://api.ipify.org?format=json");
    return response.data.ip;
  } catch (error) {
    console.error("Error fetching IP:", error);
    return null;
  }
};
